export enum userDetailsTabs {
	info = 'info',
	subscribtions = 'subscribtions',
	billing = 'billing',
	coUsers = 'co-users',
	additionalFeatures = 'additional-features',
}
